function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  id: "calendar-filled_inline_svg__path-1",
  d: "M0 0h14v5H0z"
}), React.createElement("path", {
  id: "calendar-filled_inline_svg__path-3",
  d: "M0 0h14v10H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "calendar-filled_inline_svg__Page-13",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "calendar-filled_inline_svg__01-\\u9996\\u9801---country---s0-v1",
  transform: "translate(-938 -28)"
}, React.createElement("g", {
  id: "calendar-filled_inline_svg__Atoms-/-Icon-/-calendar-/-solid",
  transform: "translate(938 28)"
}, React.createElement("g", {
  id: "calendar-filled_inline_svg__calendar",
  transform: "translate(5 4)"
}, React.createElement("mask", {
  id: "calendar-filled_inline_svg__mask-2",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#calendar-filled_inline_svg__path-1"
})), React.createElement("path", {
  d: "M12.5 16a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0012.5 2H11V.375A.376.376 0 0010.625 0h-.25A.376.376 0 0010 .375V2H4V.375A.376.376 0 003.625 0h-.25A.376.376 0 003 .375V2H1.5A1.5 1.5 0 000 3.5v11A1.5 1.5 0 001.5 16h11z",
  fill: "#0558E6",
  fillRule: "nonzero",
  mask: "url(#calendar-filled_inline_svg__mask-2)"
})), React.createElement("g", {
  id: "calendar-filled_inline_svg__calendar",
  transform: "translate(5 10)"
}, React.createElement("mask", {
  id: "calendar-filled_inline_svg__mask-4",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#calendar-filled_inline_svg__path-3"
})), React.createElement("path", {
  d: "M3.625-6c.206 0 .375.169.375.375V-4h6v-1.625c0-.206.169-.375.375-.375h.25c.206 0 .375.169.375.375V-4h1.5A1.5 1.5 0 0114-2.5v11a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 010 8.5v-11A1.5 1.5 0 011.5-4H3v-1.625C3-5.831 3.169-6 3.375-6zm4 11h-1.25A.376.376 0 006 5.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 008 6.625v-1.25A.376.376 0 007.625 5zm-3 0h-1.25A.376.376 0 003 5.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 005 6.625v-1.25A.376.376 0 004.625 5zm6 0h-1.25A.376.376 0 009 5.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0011 6.625v-1.25A.376.376 0 0010.625 5zm-6-3h-1.25A.376.376 0 003 2.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 005 3.625v-1.25A.376.376 0 004.625 2zm3 0h-1.25A.376.376 0 006 2.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 008 3.625v-1.25A.376.376 0 007.625 2zm3 0h-1.25A.376.376 0 009 2.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0011 3.625v-1.25A.376.376 0 0010.625 2z",
  id: "calendar-filled_inline_svg__Combined-Shape",
  fill: "#47AAFF",
  fillRule: "nonzero",
  mask: "url(#calendar-filled_inline_svg__mask-4)"
})))));

function SvgCalendarFilledinline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgCalendarFilledinline;